export default __webpack_public_path__ + "static/media/UBCStudentHealth.b861075d.png";